import { graphql } from "react-relay";

export const cancel_and_reschedule_lessons_on_blacklisted_date = graphql`
  mutation CancelAndRescheduleLessonsOnBlacklistedDateMutation(
    $input: CancelAndRescheduleLessonsOnBlacklistedDateInput!
  ) {
    cancelAndRescheduleLessonsOnBlacklistedDate(input: $input) {
      success
      errors
      cancelledLessons {
        id
        status
      }
    }
  }
`;
